module.exports = __webpack_public_path__ + "img/tongcheng.ffbddc17.png";